// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import cart from './cart'
import types from './types'
import bookmakers from './bookmakers'
import oddsType from './oddsType'
import globalNotes from './globalNotes'
import chat from '../views/chat/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  cart,
  types,
  bookmakers,
  oddsType,
  globalNotes,
  chat
}

export default rootReducer
